<template>
	<v-modal>
		<template v-slot:header>
			<h1>Assign Lead</h1>
		</template>
		<form class="wide" @submit.prevent="submit">
			<loader v-if="!form.isReady()"/>
			<template v-else>
				<fieldset>
					<div>
						<div class="sr-only">
							<legend><span>Assignee</span></legend>
						</div>
						<div class="input-group">
							<label><span>Team </span>
								<select v-model="form.data.assign.team">
									<option selected value="">—</option>
									<option
										v-for="(team, teamIndex) in form.options.teams" :key="teamIndex"
										:value="team.id"
										v-html="team.name"/>
								</select>
								<div v-if="form.errors.has('assign.team')" class="error-block">
									<p v-html="form.errors.get('assign.team')"/>
								</div>
							</label>
							<label><span>Colleague </span>
								<select v-model="form.data.assign.user">
									<option selected value="">—</option>
									<option
										v-for="(colleague, colleagueIndex) in colleagues"
										:key="colleagueIndex"
										:value="colleague.id" v-html="$present('fullName', colleague.profile)"/>
								</select>
								<div v-if="form.errors.has('assign.user')" class="error-block">
									<p v-html="form.errors.get('assign.user')"/>
								</div>
							</label>
						</div>
					</div>
				</fieldset>
			</template>
		</form>
		<template v-slot:footer>
			<ul class="actions actions--right">
				<li>
					<button
						:disabled="form.processing" class="button button--secondary"
						@click.prevent="$vmodal.close()">Cancel
					</button>
				</li>
				<li>
					<process-button
						:processing="form.processing" class="button button--primary" text="Assign Lead"
						@click="assign"/>
				</li>
			</ul>
		</template>
	</v-modal>
</template>
<script>

export default {
	data() {
		return {
			form: this.newForm({
				assign: {
					team: "",
					user: "",
				},
			}),
		};
	},

	watch: {
		team: function () {
			if (
				!this.form.data.team ||
				!this.form.data.user
			) {
				return;
			}

			if (!_.find(this.colleagues, user => user.id === this.form.data.user)) {
				this.form.set("user", "");
			}
		},
	},

	props: {
		lead: {
			required: true,
			type: Object,
		},
	},

	computed: {
		team() {
			if (!this.form.data.team) {
				return null;
			}

			return _.find(this.form.options.teams, team => team.id === this.form.data.team);
		},
		colleagues() {
			if (!this.team) {
				return this.form.options.colleagues;
			}

			return this.team.all_members;
		},
	},

	methods: {
		tabChanged(tab) {
			this.form.set("myself", tab.id === "myself");
		},
		assign() {
			this.form.patch(this.route("leads/:lead/assign", this.lead)).then(response => {
				this.$store.commit("leads/UPDATE_ITEM", response.data);
				this.$vmodal.close();
			});
		},
	},

	created() {
		this.form.prepare();
		http().get("form-data/assign").then(response => {
			this.form.setOptions(response.data);
			this.form.ready();
		});
	},
};
</script>
